// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/balance_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BalanceGenerationService } from "./balance_service_pb";

/**
 * @generated from rpc bffuser.v1.BalanceGenerationService.GetGenerationDashboard
 */
export const getGenerationDashboard = BalanceGenerationService.method.getGenerationDashboard;

/**
 * @generated from rpc bffuser.v1.BalanceGenerationService.GetGenerationDetail
 */
export const getGenerationDetail = BalanceGenerationService.method.getGenerationDetail;
